import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchLegalCompanyComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getAllLegalCompanyCombo from '../../services/legalCompany/getAllLegalCompanyCombo'

export function * fetchLegalCompanyCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const legalCompanies = yield call(getAllLegalCompanyCombo, auth.token)
    yield put(fetchLegalCompanyComboSuccess(legalCompanies))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchLegalCompanyCombo () {
  yield takeLatest(combosActionTypes.FETCH_LEGAL_COMPANY_COMBO, fetchLegalCompanyCombo)
}
